import { render, staticRenderFns } from "./SideNavDivider.vue?vue&type=template&id=b64d49e8&scoped=true&"
import script from "./SideNavDivider.vue?vue&type=script&lang=js&"
export * from "./SideNavDivider.vue?vue&type=script&lang=js&"
import style0 from "./SideNavDivider.vue?vue&type=style&index=0&id=b64d49e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64d49e8",
  null
  
)

component.options.__file = "SideNavDivider.vue"
export default component.exports